const translation = {
  // New navigation keys
  nav_home: "الرئيسية",
  nav_categories: "الفئات",
  nav_routes: "المسارات",
  nav_map: "الخريطة",
  nav_for_business: "عملي",
  nav_explore_btn: "استكشف",
  nav_cat_historical: "المواقع التاريخية",
  nav_cat_food: "الطعام والشراب",
  nav_cat_entertainment: "الترفيه",
  nav_cat_accommodation: "الإقامة",
  nav_cat_nature: "الطبيعة والمسارات",
  nav_cat_sightseeing: "المعالم السياحية",
  nav_cat_featured: "الأماكن المميزة",
  // Hero new keys
  hero_title_1: "اكتشف",
  hero_title_2: "بورصة",
  hero_title_3: "٣٦٠°",
  hero_subtitle: "المباني التاريخية، الجمال الطبيعي، محطات الطعام — دليلك الشامل لكل زاوية في بورصة.",
  hero_search_placeholder: "ابحث عن أماكن أو فئات أو مسارات...",
  hero_search_btn: "بحث",
  hero_stat_1_num: "٥٠٠+",
  hero_stat_1_label: "أماكن للاكتشاف",
  hero_stat_2_num: "٨٥+",
  hero_stat_2_label: "محطة طعام",
  hero_stat_3_num: "١٢",
  hero_stat_3_label: "مسار جاهز",
  hero_stat_4_num: "٤.٨",
  hero_stat_4_label: "متوسط التقييم",
  hero_quick_label: "وصول سريع:",
  hero_quick_history: "تاريخي",
  hero_quick_food: "طعام",
  hero_quick_nature: "طبيعة",
  hero_quick_hotels: "فنادق",
  hero_quick_fun: "ترفيه",
  // Categories
  cat_section_badge: "الفئات",
  cat_section_title: "ماذا تريد أن تكتشف؟",
  cat_section_subtitle: "من المواقع التاريخية إلى مسارات الطبيعة، من الطعام إلى الإقامة — كل شيء هنا.",
  cat_historical_title: "المواقع التاريخية",
  cat_historical_desc: "التراث العثماني ومواقع اليونسكو والأماكن التاريخية",
  cat_historical_count: "١٢٠+ مكان",
  cat_food_title: "الطعام والشراب",
  cat_food_desc: "إسكندر والكفتة ونكهات بورصة الفريدة",
  cat_food_count: "٨٥+ مطعم",
  cat_entertainment_title: "الترفيه",
  cat_entertainment_desc: "حدائق المغامرات والأنشطة والحياة الليلية",
  cat_entertainment_count: "٦٠+ مكان",
  cat_accommodation_title: "الإقامة",
  cat_accommodation_desc: "الفنادق الفاخرة والمنتجعات الحرارية",
  cat_accommodation_count: "٢٠٠+ خيار",
  cat_nature_title: "الطبيعة والمسارات",
  cat_nature_desc: "أولوداغ والبحيرات والمسارات والطبيعة",
  cat_nature_count: "٤٠+ مسار",
  cat_sightseeing_title: "المعالم السياحية",
  cat_sightseeing_desc: "المتاحف والأسواق والقرى ونقاط البانوراما",
  cat_sightseeing_count: "٩٥+ مكان",
  cat_featured_title: "الأماكن المميزة",
  cat_featured_desc: "أفضل العناوين التي يوصي بها محررونا",
  cat_featured_count: "اختيار المحررين",
  cat_view_all: "عرض الكل",
  // Featured
  featured_badge: "مميز",
  featured_title: "توصيات هذا الأسبوع",
  featured_subtitle: "العناوين الأكثر شعبية لدى محررينا وزوارنا.",
  featured_view_all: "عرض جميع الأماكن",
  featured_sponsored: "ممول",
  featured_editor: "اختيار المحرر",
  featured_open: "مفتوح",
  featured_closed: "مغلق",
  featured_details: "التفاصيل",
  featured_directions: "الاتجاهات",
  featured_km_away: "كم بعيداً",
  featured_reviews: "تقييمات",
  // Routes
  routes_badge: "مسارات جاهزة",
  routes_title: "خطط لزيارة بورصة",
  routes_subtitle: "اقتراحات مسارات من الخبراء — اختر حسب وقتك واهتمامك.",
  routes_view_all: "جميع المسارات",
  routes_hours: "ساعات",
  routes_stops: "محطات",
  routes_start: "ابدأ المسار",
  routes_difficulty_easy: "سهل",
  routes_difficulty_medium: "متوسط",
  routes_difficulty_hard: "صعب",
  routes_day1_title: "بورصة في يوم واحد",
  routes_day1_desc: "اكتشف أكثر الأماكن شهرة في المدينة في يوم واحد",
  routes_history_title: "مسار بورصة التاريخي",
  routes_history_desc: "جولة تاريخية شاملة تتبع خطى العثمانيين",
  routes_food_title: "جولة الطعام",
  routes_food_desc: "اكتشف أفضل نكهات بورصة طوال اليوم",
  routes_family_title: "مسار العائلة",
  routes_family_desc: "جولة ممتعة ومريحة لبورصة للأطفال والعائلات",
  routes_weekend_title: "خطة نهاية الأسبوع",
  routes_weekend_desc: "تجربة بورصة شاملة لمدة يومين",
  // Nearby
  nearby_badge: "لك خاصة",
  nearby_title: "أفضل المحطات القريبة منك",
  nearby_subtitle: "توصيات من فئات مختلفة بالقرب منك.",
  nearby_location_btn: "استخدام موقعي",
  nearby_using_location: "جارٍ تحديد الموقع...",
  nearby_view_all: "عرض المزيد",
  nearby_km_away: "كم بعيداً",
  nearby_permission_title: "شاهد الأماكن القريبة",
  nearby_permission_desc: "شارك موقعك وسنريك أقرب المواقع التاريخية والمطاعم والفنادق.",
  nearby_no_permission: "تم رفض الوصول إلى الموقع.",
  // Campaigns
  campaigns_badge: "عروض",
  campaigns_title: "حملات وخصومات",
  campaigns_subtitle: "عروض خاصة وكوبونات في أفضل أماكن بورصة.",
  campaigns_view_all: "جميع الحملات",
  campaigns_expires: "تنتهي في",
  campaigns_get_coupon: "احصل على الكوبون",
  campaigns_sponsored: "ممول",
  campaigns_discount: "خصم",
  // Chatbot
  chatbot_title: "مساعد بورصة",
  chatbot_subtitle: "اسأل عن المسارات والأماكن",
  chatbot_greeting: "مرحبا! ماذا تريد أن تفعل في بورصة؟ يسعدني مساعدتك بأفضل المسارات والتوصيات.",
  chatbot_placeholder: "اسأل شيئاً...",
  chatbot_send: "إرسال",
  chatbot_suggestion_1: "ماذا يمكنني أن أفعل اليوم؟",
  chatbot_suggestion_2: "أفضل المواقع التاريخية",
  chatbot_suggestion_3: "اقترح مساراً",
  chatbot_suggestion_4: "أين أذهب مع الأطفال؟",
  chatbot_suggestion_5: "أفضل المطاعم",
  // Footer new keys
  footer_tagline: "اكتشف بورصة ٣٦٠°",
  footer_links_title: "روابط سريعة",
  footer_categories_title: "الفئات",
  footer_contact_title: "تواصل",
  footer_for_business: "لعملي",
  footer_newsletter_title: "أخبار بورصة",
  footer_newsletter_desc: "كن أول من يعلم بالأماكن الجديدة والحملات.",
  footer_newsletter_placeholder: "بريدك الإلكتروني",
  footer_newsletter_btn: "اشترك",
  // Common
  common_open: "مفتوح",
  common_closed: "مغلق",
  common_sponsored: "ممول",
  common_featured: "مميز",
  common_editor_pick: "اختيار المحرر",
  common_view_details: "عرض التفاصيل",
  common_get_directions: "احصل على الاتجاهات",
  common_book_now: "احجز الآن",
  common_explore: "استكشف",
  common_see_all: "عرض الكل",
  common_km_away: "كم بعيداً",
  nav_discover: "اكتشف",
  nav_discover_history: "التاريخ",
  nav_discover_nature: "الطبيعة",
  nav_discover_modern: "بورصة الحديثة",
  nav_eat: "كل واشرب",
  nav_eat_iskender: "إسكندر كباب",
  nav_eat_kofte: "كفتة بالخبز",
  nav_eat_tahin: "فطير الطحينة",
  nav_todo: "ما يمكن فعله",
  nav_todo_activity: "الأنشطة",
  nav_todo_adventure: "المغامرة",
  nav_plan: "خطط",
  nav_plan_transport: "المواصلات",
  nav_plan_maps: "الخرائط",
  nav_plan_hotels: "الفنادق",

  hero_badge: "جنة تركيا الخضراء",
  hero_title: "ماذا تفعل في",
  hero_title_green: "بورصة اليوم؟",
  hero_desc: "من الخانات التاريخية إلى القمم المليئة بالإثارة: أفضل دليل 360° لبورصة.",
  hero_cta_explore: "ابدأ الاستكشاف",
  hero_cta_plan: "خطط جولتك",
  hero_stat_site: "مواقع تاريخية",
  hero_stat_restaurant: "نكهات محلية",
  hero_stat_activity: "الأنشطة",

  biglist_badge: "اختيارات المحرر",
  biglist_title: "أفضل 10 أشياء للقيام بها في بورصة",
  biglist_desc: "في يوم أو أسبوع أو عمر: القائمة التي تلتقط روح المدينة.",
  biglist_btn: "التفاصيل",
  biglist_must: "لا تفوته",
  bl1_num: "٠١",
  bl1_title: "استكشف تراث اليونسكو",
  bl1_sub: "حي البازارات والجامع الكبير",
  bl1_desc: "قصة تأسيس الإمبراطورية العثمانية محفورة في هذه الجدران الحجرية. خصص ساعتين على الأقل لقهوة تركية في البزازستان وجرعة من التاريخ.",
  bl2_num: "٠٢",
  bl2_title: "اشحن الأدرينالين على القمة",
  bl2_sub: "إكستريم بارك بورصة — نقطة الهروب #1",
  bl2_desc: "إذا كانت بورصة تعني لك التاريخ فحسب، فأنت لم تتعرف بعد على إثارة 2000 متر. التزلج الجبلي ومسارات الحبال والأرجوحة العملاقة — لم ترَ بورصة بهذه الطريقة من قبل.",
  bl2_tag: "اختيار المحرر",
  bl3_num: "٠٣",
  bl3_title: "فطور في جوماليكيزيك",
  bl3_sub: "قرية عثمانية عمرها 700 سنة",
  bl3_desc: "التجول في الشوارع المرصوفة عند شروق الشمس، فطور قروي بالطماطم والجبن. هذه التجربة ستكون أسطورية على وسائل التواصل الاجتماعي أيضاً.",
  bl4_num: "٠٤",
  bl4_title: "تجربة التلفريك",
  bl4_sub: "من أطول الخطوط في العالم",
  bl4_desc: "رحلة بانورامية من المدينة إلى قمة أولوداغ. احتفظ بكاميرتك مشحونة.",
  bl5_num: "٠٥",
  bl5_title: "يتوقف الزمن عند الضريح الأخضر",
  bl5_sub: "تحفة الفسيفساء العثمانية",
  bl5_desc: "بداخله يتلاشى كل إحساس بالوقت. انظر إلى لون البلاط: لقد كان بهذا اللون منذ 6 قرون.",
  bl6_num: "٠٦",
  bl6_title: "كُل إسكندر حقيقي",
  bl6_sub: "نفس الوصفة منذ 1867",
  bl6_desc: "خبز مع لحم وطماطم وزبدة. لا تغادر بورصة دون أن تأكله. لا تغادر.",
  bl7_num: "٠٧",
  bl7_title: "اضِع في غولياضي",
  bl7_sub: "بحيرة هادئة وبيوت خشبية",
  bl7_desc: "جزيرة هدوء مختبئة داخل بورصة. تعال هنا للجلوس على ضفة البحيرة تحت شمس الظهيرة.",
  bl8_num: "٠٨",
  bl8_title: "تزلج على أولوداغ",
  bl8_sub: "المنتجع الرئيسي للتزلج في تركيا",
  bl8_desc: "بين ديسمبر ومارس يتحول أولوداغ إلى عاصمة التزلج في تركيا. حين يأتي الشتاء، اتجه إلى هنا.",
  bl9_num: "٠٩",
  bl9_title: "قف عند ضريح أوسمان غازي",
  bl9_sub: "بداية إمبراطورية",
  bl9_desc: "مجرد التفكير في أن مؤسس الإمبراطورية يرقد هنا يثير إحساساً غريباً. اذهب في صمت الصباح.",
  bl10_num: "١٠",
  bl10_title: "استرح في الحمامات الحرارية",
  bl10_sub: "المياه الحرارية في تشيكرجه",
  bl10_desc: "جماليات الحمام العثماني ومياه حرارية غنية بالمعادن. لا شيء أفضل من هذا بعد يوم استكشاف كامل.",

  eat_badge: "مسار الذواقة",
  eat_title: "كل واشرب",
  eat_desc: "معرفة الطعام الجيد لا تضر أحداً. إليك أكثر عناوين النكهات موثوقية في المدينة.",
  eat_iskender_title: "أين تأكل أفضل إسكندر كباب؟",
  eat_iskender_desc: "هذا السؤال ذو أهمية حيوية في بورصة. ثلاثة عناوين اختيرت بسنوات من الخبرة:",
  eat_r1_name: "إسكندر أوغلو",
  eat_r1_detail: "الوصفة الأصلية، المذاق الأصيل. مزدحم، توقع طابوراً.",
  eat_r1_tag: "أصيل",
  eat_r2_name: "كباب إسكندر",
  eat_r2_detail: "مكان تاريخي تديره نفس العائلة منذ 1867.",
  eat_r2_tag: "تاريخي",
  eat_r3_name: "مطعم حاجي بي",
  eat_r3_detail: "بيئة عصرية ومذاق تقليدي. لمن يريد الهروب من الحشود.",
  eat_r3_tag: "مريح",
  eat_breakfast_title: "أماكن فطور بورصة الخفية",
  eat_breakfast_desc: "فطائر منزلية في جوماليكيزيك وبيض قروي خلف السوق المسقوف وعسل طازج... الصباحات في بورصة جميلة بشكل مختلف.",
  eat_extrempark_label: "قهوة مع مشهد",
  eat_extrempark_title: "مدرج مشاهدة إكستريم بارك",
  eat_extrempark_desc: "قهوة بينما تراقب كل بورصة تحت قدميك. حتى لو لم تكن تبحث عن الأدرينالين، هذا وحده سبب كافٍ للمجيء إلى هنا.",
  eat_see_all: "رؤية جميع الأماكن",

  adv_badge: "النشاط والمغامرة",
  adv_title: "المغامرة والطبيعة",
  adv_desc: "أولوداغ ليس مجرد جبل؛ إنه حديقة ومنتجع تزلج وساحة مغامرات.",
  adv_uludag_title: "دليل منتجع أولوداغ للتزلج",
  adv_uludag_desc: "مسارات مضمونة الثلوج من ديسمبر إلى مارس، تأجير معدات التزلج، ومطاعم جبلية. باقات للمبتدئين.",
  adv_uludag_season: "الموسم: ديسمبر — مارس",
  adv_uludag_alt: "بديل الصيف: إكستريم بارك",
  adv_xp_badge: "عرض خاص",
  adv_xp_title: "مغامرة بمعايير أوروبية: إكستريم بارك",
  adv_xp_desc: "مسارات حبال، أرجوحة عملاقة، تزلج جبلي ومدرج مشاهدة بانورامي. واحدة من أكثر حدائق المغامرات شمولاً في تركيا. لا تغادر بورصة دون المرور هنا.",
  adv_xp_f1: "التزلج الجبلي",
  adv_xp_f2: "الأرجوحة العملاقة",
  adv_xp_f3: "مسارات الحبال",
  adv_xp_f4: "مدرج المشاهدة",
  adv_xp_f5: "أنشطة الأطفال",
  adv_xp_f6: "مطعم وكافيه",
  adv_xp_ticket: "اشترِ تذكرة",
  adv_xp_reserve: "احجز مسبقاً",
  adv_xp_direction: "احصل على الاتجاهات",
  adv_other_title: "أنشطة أخرى",
  adv_act1: "التلفريك",
  adv_act1_desc: "رحلة بانورامية من المدينة إلى القمة",
  adv_act2: "المشي في الطبيعة",
  adv_act2_desc: "مسارات مميزة في الحديقة الوطنية أولوداغ",
  adv_act3: "جولات الدراجات",
  adv_act3_desc: "مسارات دراجات في المدينة والطبيعة",

  sticky_label: "الأماكن القريبة",

  qr_badge: "أهلاً وسهلاً!",
  qr_title: "أول 5 أشياء",
  qr_title_accent: "بعد مغادرة الفندق",
  qr_desc: "خمس توصيات مختارة لتستفيد أقصى استفادة من ساعاتك الأولى في بورصة.",
  qr_item1_num: "1",
  qr_item1_title: "اذهب إلى إكستريم بارك",
  qr_item1_desc: "أفضل نقطة مشاهدة وحديقة مغامرات في المدينة. شاهد كل بورصة من المدرج البانورامي. اركب الزلاجة الجبلية، اشرب قهوتك.",
  qr_item1_cta: "اشترِ تذكرة الآن",
  qr_item2_num: "2",
  qr_item2_title: "زُر الجامع الأخضر",
  qr_item2_desc: "10 دقائق من الفندق — أروع مثال على الفسيفساء العثمانية. الدخول مجاني.",
  qr_item2_cta: "احصل على الاتجاهات",
  qr_item3_num: "3",
  qr_item3_title: "كُل إسكندر كباب",
  qr_item3_desc: "اخترع في بورصة عام 1867، هذا الطبق هو هوية المدينة. قم بزيارة كباب إسكندر.",
  qr_item3_cta: "رؤية المكان",
  qr_item4_num: "4",
  qr_item4_title: "خذ التلفريك إلى أولوداغ",
  qr_item4_desc: "رحلة بانورامية 8 دقائق من المدينة إلى القمة. رائعة في كلا الاتجاهين.",
  qr_item4_cta: "رؤية المواعيد",
  qr_item5_num: "5",
  qr_item5_title: "تجول في جوماليكيزيك",
  qr_item5_desc: "15 كم من وسط المدينة، 700 سنة للوراء. البيوت الحجرية والفطور والكاميرا ضرورية.",
  qr_item5_cta: "عرض على الخريطة",
  qr_back: "العودة للدليل الكامل",
  qr_powered: "بدعم من Bursa City Guide",

  history_badge: "تراث عالمي يونسكو",
  history_title: "الإرث التاريخي",
  history_desc: "بوصفها العاصمة الأولى للإمبراطورية العثمانية، تأسر بورصة بإرثها المعماري الرائع الذي عبر القرون.",
  history_item1_title: "حي البازارات",
  history_item1_desc: "شاهد حي على تجارة العثمانيين مع الأسواق التاريخية والخانات وورش الحرف اليدوية منذ القرن الخامس عشر.",
  history_item1_duration: "٢-٣ ساعات",
  history_item2_title: "قرية جوماليكيزيك",
  history_item2_desc: "قرية ساحرة في قائمة يونسكو بتاريخ ٧٠٠ سنة، تعرض العمارة العثمانية التقليدية بأنقى صورها.",
  history_item2_duration: "نصف يوم",
  history_item3_title: "ضريح أوسمان غازي",
  history_item3_desc: "ضريح مؤسس الدولة العثمانية أوسمان غازي — بوابة روحية تنفتح على أعماق التاريخ.",
  history_item3_duration: "ساعة",
  history_item4_title: "الجامع والضريح الأخضر",
  history_item4_desc: "تحفة معمارية إسلامية تركية، رمز بورصة بفسيفسائها الفريد.",
  history_item4_duration: "١-٢ ساعة",
  history_tip: "نصيحة محلية",
  history_tip_text: "قم بزيارة جوماليكيزيك في الصباح الباكر، ثم استكشف حي البازارات لتناول الغداء وتناول القهوة في خان تاريخي.",
  history_visit: "زُر الآن",

  food_badge: "مطبخ بورصة",
  food_title: "محطات الطعام",
  food_desc: "تحتل بورصة مكانة خاصة في خريطة الطهي التركي بنكهاتها الفريدة التي ستترك أثرًا دائمًا.",
  food_item1_title: "إسكندر كباب",
  food_item1_desc: "اخترع في بورصة عام ١٨٦٧ وشهير عالميًا، يُقدَّم باللحم المقطّع رفيعًا والخبز وزبدة السمن.",
  food_item1_where: "أين: مطعم حاجي بي، بيت إسكندر كباب",
  food_item2_title: "كفتة بالخبز",
  food_item2_desc: "طبق الكفتة الخاص ببورصة يُقدَّم فوق الخبز مع صلصة الطماطم والزبادي.",
  food_item2_where: "أين: بيت الكفتة التاريخي، داخل السوق المسقوف",
  food_item3_title: "حلوى الكستناء",
  food_item3_desc: "أصبحت الكستناء المسكّرة رمزًا لبورصة — إنها حلوى شهية وهدية مثالية.",
  food_item3_where: "أين: السوق المسقوف، السوق التاريخية",
  food_item4_title: "بوزا أولوداغ",
  food_item4_desc: "مشروب البوزا التقليدي، يُشرب ساخنًا شتاءً وباردًا صيفًا، مشروب أسطوري يباع في شوارع بورصة.",
  food_item4_where: "أين: محلات البوزا التاريخية، حول السوق المسقوف",
  food_map_btn: "خريطة الطعام",
  food_must_try: "يجب التجربة",
  food_local_fav: "المفضل المحلي",

  adventure_badge: "أدرينالين ومغامرة",
  adventure_title: "المغامرة والترفيه",
  adventure_desc: "عند سفح أولوداغ، تنتظرك أنشطة مثيرة ولحظات لا تُنسى في أحضان الطبيعة.",
  adventure_featured_badge: "أفضل منظر في المدينة",
  adventure_featured_title: "شاهد بورصة من القمة مع إكستريم بارك",
  adventure_featured_desc: "إذا أردت الهروب من ضجيج المدينة وقضاء يوم مثير في غابات الصنوبر، فإن إكستريم بارك — أحد أكبر حدائق المغامرات في تركيا — يوفر لك مدرجًا بانوراميًا بلا مثيل يطل على بورصة، فضلًا عن أنشطة مثل التزلج الجبلي التي تمنحك ذكريات لا تُنسى.",
  adventure_feat1: "مدرج مشاهدة بانورامي",
  adventure_feat2: "التزلج الجبلي",
  adventure_feat3: "الزيب لاين والتسلق",
  adventure_feat4: "أنشطة الأطفال",
  adventure_visit_btn: "زيارة إكستريم بارك",
  adventure_more_title: "أنشطة أخرى",
  adventure_act1: "منتجع أولوداغ للتزلج",
  adventure_act1_desc: "أكثر منتجعات التزلج شعبية في تركيا شتاءً",
  adventure_act2: "جولة التلفريك",
  adventure_act2_desc: "مناظر بانورامية فريدة من المدينة إلى أولوداغ",
  adventure_act3: "مسارات المشي",
  adventure_act3_desc: "مسارات محددة في الحديقة الوطنية أولوداغ",

  modern_badge: "مدينة حية",
  modern_title: "بورصة الحديثة والطبيعة",
  modern_desc: "تنمو بورصة في ظل التاريخ، وفي نفس الوقت هي موطن لحياة مدنية حديثة نابضة وجمال طبيعي لا مثيل له.",
  modern_item1_title: "بورصة سيتي بارك",
  modern_item1_desc: "مركز تسوق وترفيه حديث في قلب المدينة",
  modern_item2_title: "المتنزهات الطبيعية",
  modern_item2_desc: "مسارات المشي وأماكن التنزه عند سفح أولوداغ",
  modern_item3_title: "صالات الفنون",
  modern_item3_desc: "الفن المعاصر والتحف العثمانية جنبًا إلى جنب",
  photo_badge: "للمصورين",
  photo_title: "أفضل نقاط التصوير في بورصة",
  photo_desc: "إذا أردت التقاط صور مثالية لحساباتك على التواصل الاجتماعي، فهذه المواقع لن تخذلك.",
  photo_1_title: "مدرج مشاهدة إكستريم بارك",
  photo_1_desc: "نقطة التصوير #١ حيث ترى كل بورصة تحت قدميك. رائعة عند الغروب.",
  photo_1_tag: "#١ أفضل موقع",
  photo_2_title: "قمة أولوداغ",
  photo_2_desc: "لقطات ملحمية فوق القمم الثلجية والسحاب",
  photo_3_title: "شوارع جوماليكيزيك",
  photo_3_desc: "لقطات خيالية بين الجدران الحجرية والزهور الملونة",
  photo_4_title: "فناء الجامع الأخضر",
  photo_4_desc: "لقطات فنية حيث ترقص العمارة العثمانية والفسيفساء معًا",
  photo_5_title: "على متن التلفريك",
  photo_5_desc: "مشهد بانورامي لبورصة أثناء العبور فوق المدينة",

  practical_badge: "دليل الزوار",
  practical_title: "معلومات عملية",
  practical_desc: "كل ما تحتاجه لاستكشاف بورصة بأفضل طريقة.",
  transport_title: "المواصلات",
  transport_item1: "حافلة من إسطنبول: ٢-٣ ساعات",
  transport_item2: "حافلة بحرية (مودانيا): ١.٥ ساعة",
  transport_item3: "مترو وترام داخل المدينة",
  transport_item4: "التلفريك: ٠٨:٠٠ - ٢٢:٠٠",
  cable_title: "مواعيد التلفريك",
  cable_summer: "الصيف (أبريل-أكتوبر)",
  cable_summer_time: "٠٨:٠٠ - ٢٢:٠٠",
  cable_winter: "الشتاء (نوفمبر-مارس)",
  cable_winter_time: "٠٩:٠٠ - ٢١:٠٠",
  cable_note: "يخضع للتغيير حسب الأحوال الجوية",
  contacts_title: "أرقام مهمة",
  contact1: "إرشاد السياحة في بورصة",
  contact2: "خدمات الطوارئ",
  contact3: "مستشفى المدينة",
  contact4: "منتجع أولوداغ للتزلج",
  weather_title: "المناخ وأفضل وقت للزيارة",
  weather_spring: "الربيع (مارس-مايو)",
  weather_spring_desc: "أزهار وخضرة، طقس مثالي للمشي",
  weather_summer: "الصيف (يونيو-أغسطس)",
  weather_summer_desc: "دافئ، مثالي للفعاليات والرياضات الخارجية",
  weather_fall: "الخريف (سبتمبر-نوفمبر)",
  weather_fall_desc: "أوراق ملونة، موسم حصاد الكستناء",
  weather_winter: "الشتاء (ديسمبر-فبراير)",
  weather_winter_desc: "موسم التزلج ومهرجانات الثلج",

  footer_tagline: "بمساهمات تطوير السياحة في بورصة",
  footer_desc: "تم إعداد هذا الدليل لتعريف جميع الزوار بتاريخ بورصة وثقافتها وجمالها الطبيعي بأفضل طريقة ممكنة.",
  footer_quick: "وصول سريع",
  footer_contact: "تواصل",
  footer_address: "عثمان غازي، بورصة، تركيا",
  footer_phone: "+90 224 000 0000",
  footer_email: "info@bursacityguide.com",
  footer_rights: "© 2026 Bursa City Guide. جميع الحقوق محفوظة.",
  footer_privacy: "سياسة الخصوصية",
  footer_terms: "شروط الاستخدام",
};

export default translation;
